"use client";
import { useLocale, useTranslations } from "next-intl";
import Link from "next/link";

export default function Navigate({
  name,
  second = "",
}: {
  name: string;
  second?: string;
}) {
  const t = useTranslations("Nav");
  const locale = useLocale();

  return (
    <div className="flex items-center gap-2 mb-6 select-none flex-wrap">
      <Link
        href={"/"}
        className="text-xs xm:text-sm sm:text-lg font-bold text-dark/60"
      >
        {t("home")}
      </Link>
      <span className="xm:text-sm sm:text-lg">
        {locale === "en" ? ">" : "<"}
      </span>

      {second && second !== "" && (
        <>
          <Link
            href={`/${name}`}
            className="text-xs xm:text-sm sm:text-lg font-bold text-dark/60"
          >
            {t(name)}
          </Link>
          <span className="xm:text-sm sm:text-lg">
            {locale === "en" ? ">" : "<"}
          </span>
        </>
      )}

      <h2 className="text-xs xm:text-sm sm:text-lg font-bold text-main">
        {second !== "" ? second : t(name)}
      </h2>
    </div>
  );
}
